import { ReactElement } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

import { PropsWithChildren } from 'lib/@types';

const Card = ({
  children,
  ...props
}: PropsWithChildren<BoxProps>): ReactElement => (
  <Box p={8} pb={[8, 16]} borderRadius={32} minH='100%' {...props}>
    {children}
  </Box>
);

export default Card;
